// Beeches Brook paw mark — carried verbatim from _prototype/components.jsx.
export function BrandMark({ size = 36 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg" className="brand-svg">
      <circle cx="16" cy="17" r="14" fill="var(--brand-soft)" />
      <ellipse cx="8.4" cy="13.4" rx="2.2" ry="2.7" fill="var(--brand)" transform="rotate(-12 8.4 13.4)" />
      <ellipse cx="23.6" cy="13.4" rx="2.2" ry="2.7" fill="var(--brand)" transform="rotate(12 23.6 13.4)" />
      <ellipse cx="13" cy="9.6" rx="2.4" ry="2.9" fill="var(--brand)" transform="rotate(-4 13 9.6)" />
      <ellipse cx="19" cy="9.6" rx="2.4" ry="2.9" fill="var(--brand)" transform="rotate(4 19 9.6)" />
      <path
        d="M10.5 18.4 Q10.5 15.4 16 15.4 Q21.5 15.4 21.5 18.4 L22 22.2 Q22 25.6 16 25.6 Q10 25.6 10 22.2 Z"
        fill="var(--brand)"
      />
    </svg>
  );
}
